import type { JsonLdObject } from "@/lib/schema";

/**
 * Injeta um objeto como <script type="application/ld+json">.
 * Renderizado pelo servidor: sai no HTML da primeira resposta.
 */
export function JsonLd({ data }: { data: JsonLdObject | null | undefined }) {
  if (!data) return null;

  // Escape de "<" para que nenhum valor do banco possa fechar a tag script.
  const json = JSON.stringify(data).replace(/</g, "\\u003c");

  return (
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: json }} suppressHydrationWarning />
  );
}

export default JsonLd;
